import { Checkbox, Col, Form, Input, Row, Select } from "antd";
import React, { FC } from "react";

type CommunicationAddressProps = {
  form: any;
};

const CommunicationAddress: FC<CommunicationAddressProps> = ({ form }) => {
  return (
    <>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "10px",
          fontWeight: "bold",
        }}
      >
        Communication Address
      </div>

      <Form
        form={form}
        layout="vertical"
        labelAlign="left"
        style={{ width: "100%" }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label="Pincode"
              name="pincode"
              rules={[
                {
                  // required: true,
                  message: "Please enter pin code",
                },
                {
                  pattern: /^\d{6}$/,
                  message: "PIN CODE MUST BE 6 DIGITS!",
                },
              ]}
            >
              <Input placeholder="Type here" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item
              label="Village/Town/City"
              name="city"
              rules={[{ 
                // required: true,
                 message: "Please enter city" }]}
            >
              <Input placeholder="Type here" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default CommunicationAddress;
